import { AutogenLayoutDriverEmploymentHistory } from "./autogen/AutogenLayoutDriverEmploymentHistory";
import {  BlurEvent } from "@mcleod/components";

export class DriverEmploymentHistory extends AutogenLayoutDriverEmploymentHistory {

}
